import type { ChainNetwork, ProtoProfile } from '@ducat-unit/core';
import { proto } from '@ducat-unit/core/schema';

/** Keep the SDK's full schema check, and reject another chain's configuration. */
export function parseProtocolProfile(value: unknown, network: ChainNetwork): ProtoProfile {
  const result = proto.profile.safeParse(value);
  if (!result.success || result.data.chain_network !== network) {
    throw new Error('Invalid protocol configuration');
  }
  return result.data;
}
